import styled from 'styled-components';

interface IContainerProps {
  $withSpacing?: boolean;
}
export const Container = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  padding: ${props => (props.$withSpacing ? '0 0 2rem' : '0')};
`;
export const TitleScreen = styled.p`
  color: #9f9f9f;
  font-size: 1rem;
  font-weight: bold;
  margin: 0 0 1.2rem;
`;
export const BackgroundImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 64px;
  width: calc(100% - 64px);
  margin: auto auto 0;
  opacity: 0.5;
  z-index: -1;

  @media (min-width: 1921px) {
    max-width: calc(90% - 64px);
    left: 50%;
    transform: translateX(-50%);
  }
  @media (max-width: 468px) {
    display: none;
  }
`;

